import * as React from 'react';
import DataString from './DataString';


interface InfoPanelProps {
    data: Array<{ title: string, value?: string | null | undefined }>
}


export default class InfoPanel extends React.PureComponent<InfoPanelProps> {

    public render() {
        return (
            <div className='info-panel'>
                {this.props.data.map((element, index) => {
                    return <DataString key={index} title={element.title} value={element.value} isNormal={true} />
                })}
            </div>
        );
    }
}